function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 22C19.3137 22 22 19.3137 22 16C22 12.6863 19.3137 10 16 10C12.6863 10 10 12.6863 10 16C10 19.3137 12.6863 22 16 22Z",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.9625 8.1375C23.2791 8.42916 23.5791 8.72916 23.8624 9.0375L27.275 9.525C27.831 10.4906 28.2595 11.5242 28.5499 12.6L26.475 15.3625C26.475 15.3625 26.5125 16.2125 26.475 16.6375L28.5499 19.4C28.2609 20.4762 27.8322 21.51 27.275 22.475L23.8624 22.9625C23.8624 22.9625 23.275 23.575 22.9625 23.8625L22.475 27.275C21.5093 27.831 20.4757 28.2596 19.4 28.55L16.6375 26.475C16.2133 26.5125 15.7866 26.5125 15.3625 26.475L12.6 28.55C11.5237 28.2609 10.49 27.8323 9.52495 27.275L9.03745 23.8625C8.72912 23.5708 8.42912 23.2708 8.13745 22.9625L4.72495 22.475C4.16893 21.5094 3.74036 20.4758 3.44995 19.4L5.52495 16.6375C5.52495 16.6375 5.48745 15.7875 5.52495 15.3625L3.44995 12.6C3.73902 11.5238 4.16765 10.49 4.72495 9.525L8.13745 9.0375C8.42912 8.72916 8.72912 8.42916 9.03745 8.1375L9.52495 4.725C10.4906 4.16897 11.5242 3.74041 12.6 3.45L15.3625 5.525C15.7866 5.48749 16.2133 5.48749 16.6375 5.525L19.4 3.45C20.4762 3.73906 21.5099 4.1677 22.475 4.725L22.9625 8.1375Z",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgSettings = function SvgSettings(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Settings.59ca73ae.svg";
export { ForwardRef as ReactComponent };